import { render, staticRenderFns } from "./IBanInput.vue?vue&type=template&id=69b59d92"
import script from "./IBanInput.vue?vue&type=script&lang=js"
export * from "./IBanInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports